export default __webpack_public_path__ + "static/media/bags-everywhere.a487467c.jpg";